import { Flex, Text, Button, Box, useDisclosure } from '@chakra-ui/react'
import { Id } from '../convex/_generated/dataModel'
import { FaEdit } from 'react-icons/fa'
import { FiArrowLeft, FiEdit2, FiEdit3, FiPlus } from 'react-icons/fi'
import { Link, useParams } from 'react-router-dom'
import ProjectFormModal from '../components/Modals/ProjectFormModal'
import { useMutation, useQuery } from '../convex/_generated/react'
import Estimate from '../Estimate'

const Proposal = () => {
  const { id } = useParams()
  const proposal = useQuery('proposalById', new Id('proposals', `${id}`))
  const createEstimate = useMutation('createEstimate')
  const { isOpen, onOpen, onClose } = useDisclosure()

  if (!proposal) {
    return null
  }

  const { project } = proposal

  const handleNewEstimate = () => {
    createEstimate({
      name: `Estimate ${(proposal.estimates || []).length + 1}`,
      resources: [],
      proposalId: proposal._id
    })
  }

  const handleEditProject = () => {
    onOpen()
  }

  return (
    <div>
      <Flex alignItems="center" justifyContent="space-between">
        <Link to="/proposals">
          <Flex alignItems="center" gap={3}>
            <FiArrowLeft size={35} />
            <Flex direction="column">
              <Text fontSize='3xl'>{ proposal?.name }</Text>
              <Text fontSize='md'>for {`${project.name}, ${project.startDate} to ${project.endDate}`}</Text>
            </Flex>
          </Flex>
        </Link>
        <Flex gap={3}>
          <Button onClick={handleEditProject}><FiEdit2 />&nbsp;&nbsp;Edit Project</Button>
          <Button colorScheme={'purple'} onClick={handleNewEstimate}><FiPlus />&nbsp;&nbsp;New Estimate</Button>
        </Flex>
      </Flex>

      <Box mt={5}>
      {
        (proposal.estimates || []).map(
          (estimate, index) =>
            <Estimate
              mb={4}
              estimate={estimate}
              key={index}
            />
        )
      }
      </Box>
      {
        project
          ? <ProjectFormModal
              isOpen={isOpen}
              onClose={onClose}
              _id={project._id}
            />
          : null
      }
    </div>
  )
}

export default Proposal
